import React from 'react'
import classnames from 'classnames'

import { Station, StationFood } from '../../../core/stations'
import { foodTableContent } from './each-station-content'
import styles from '../../styles/modules/table.module.scss'
import foodTableStyles from '../../styles/modules/each-station/food-table.module.scss'
import Switch from 'react-switch'

interface Props {
  station: Station
  foods: StationFood[]
  setStationFoodAvailable: (foodId: number, stationId: number) => void
  setStationFoodAvailableTemporarily: (
    foodId: number,
    stationId: number
  ) => void
  setStationFoodUnavailable: (foodId: number, stationId: number) => void
  setStationFoodUnavailableTemporarily: (
    foodId: number,
    stationId: number
  ) => void
  canUpdateAvailability: boolean
}

const FoodTable: React.FC<Props> = props => {
  const handleOnClickSetStationFoodUnavailable = (
    foodName: string,
    foodId: number,
    stationId: number
  ) => {
    const response = window.confirm(
      `本当に${foodName}のフードを取り扱い不可にしますか？`
    )
    if (response) {
      props.setStationFoodUnavailable(foodId, stationId)
    }
  }

  const handleOnClickSetStationFoodAvailable = (
    foodName: string,
    foodId: number,
    stationId: number
  ) => {
    const response = window.confirm(
      `本当に${foodName}のフードを取り扱い可能しますか？`
    )
    if (response) {
      props.setStationFoodAvailable(foodId, stationId)
    }
  }

  return (
    <div
      className={classnames({
        [styles.wrapper]: true,
        [styles.zebra]: true,
        [styles.stocker]: true,
      })}
    >
      <table
        className={classnames(
          styles.container,
          styles.itemTable,
          foodTableStyles.foodTable
        )}
      >
        <tbody>
          <tr className={styles.row}>
            {foodTableContent.map(food => (
              <th key={food} className={styles.cell}>
                {food}
              </th>
            ))}
          </tr>
          {props.foods.map(food => (
            <tr className={styles.row} key={food.id}>
              <td className={styles.cell}>{food.id}</td>
              <td className={styles.cell}>{food.name}</td>
              <td className={styles.cell}>
                <div
                  className={classnames(foodTableStyles.switchContainer, {
                    [foodTableStyles.disabledSwitch]:
                      !props.canUpdateAvailability,
                  })}
                  title={
                    props.canUpdateAvailability
                      ? undefined
                      : '取扱可否を変更する権限がありません'
                  }
                >
                  <Switch
                    disabled={!props.canUpdateAvailability}
                    onChange={() => {
                      if (!props.canUpdateAvailability) {
                        return
                      }
                      food.status !== 'unavailable'
                        ? handleOnClickSetStationFoodUnavailable(
                            food.name,
                            food.id,
                            props.station.id
                          )
                        : handleOnClickSetStationFoodAvailable(
                            food.name,
                            food.id,
                            props.station.id
                          )
                    }}
                    checked={food.status !== 'unavailable'}
                  />
                </div>
              </td>
              <td className={styles.cell}>
                <div className={foodTableStyles.switchContainer}>
                  {food.status !== 'unavailable' ? (
                    <Switch
                      onChange={() => {
                        food.status !== 'unavailable_temporarily'
                          ? props.setStationFoodUnavailableTemporarily(
                              food.id,
                              props.station.id
                            )
                          : props.setStationFoodAvailableTemporarily(
                              food.id,
                              props.station.id
                            )
                      }}
                      checked={food.status !== 'unavailable_temporarily'}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default FoodTable
